module.exports = __webpack_public_path__ + "img/banner@3x.6c572311.png";